import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { Form } from "react-bootstrap";
import { Dashboard_Client_Report } from "../../Configuration/API_URL";
import Header from "../../Components/Header";
import CombineLedger from "../../Components/ReportTables/CombineLedger";
import { Client_Search } from "../../Configuration/API_URL";
import ReportTableHeader from "../../Components/ReportTables/ReportTableHeader";
import Loader from "../../Components/Common/Loader";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
  compareDate,
  decryptData,
  encryptData,
  noDataFound,
} from "../../CommonMethhods/CommonMethods";
import { Constants } from "../../CommonMethhods/Constants";
import "react-toastify/dist/ReactToastify.css";
import FromdateComponent from "./FromdateComponent";
import TodateComponent from "./TodateComponent";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import { toast } from "react-toastify";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import { Partner_Reports } from "../../Configuration/Partner_URL";
import { useDebounce } from "../../Components/useDebounce";
import DurationChangeComponent from "./DurationChangeComponent";

function CombineLedgerReport() {
  const userType = localStorage.getItem("partnerType").toLowerCase();
  const partnerRoleNew = localStorage.getItem("partnerRoleNew")?.toLowerCase()
  const partnerSsoToken = localStorage.getItem("partnerSsoToken");
  const storeToken = localStorage.getItem("ssoToken");
  const [fileType, setFileType] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [flag, setFlag] = useState("voucherDate");
  const [gridVal, setGridVal] = useState([]);
  const [loader, setLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [errorResp, setErrorResp] = useState("");
  const [page, setPage] = useState(1);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [clientCode, setClientCode] = useState("");
  const [smallLoaderMail, setSmallLoaderMail] = useState(false);
  const [count, setCount] = useState(0);
  const [noNameFoundError, setNoNameFoundError] = useState("");
  const [blankClientCodeError, setBlankClientCodeError] = useState("");
  const [show, setShow] = useState(false);
  const [noReportFound, setNoReportFound] = useState(false);
  const [voucherType, setVoucherType] = useState([])
  const [exchangeType, setExchangeType] = useState([])
  const [reportType, setReportType] = useState([])
  const [voucher, setVoucher] = useState("")
  const [exchange, setExchange] = useState([])
  const [report, setReport] = useState("")
  const [customShow, setCustomShow] = useState(false)
   const [selectDuration,setSelectDuration]=useState("");
   const [exchangeShow, setExchangeShow] = useState(false);
    const exchangeDropdownRef = useRef(null);
    

  const debouncedClientCode = useDebounce(clientCode, 1000);

  useEffect(() => {
    if (debouncedClientCode) {
      searchApiDetail(debouncedClientCode, 1);
      setScrollLoader(true);
      setClientList([]);
      setPage(1);
    }
  }, [debouncedClientCode]);

  const handleClickOutside = (event) => {
    if (
      exchangeDropdownRef.current &&
      !exchangeDropdownRef.current.contains(event.target)
    ) {
      setExchangeShow(false);
    }
  };

  useEffect(() => {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

  useEffect(() => {
    if (page > 1) {
      searchApiDetail(clientCode, page);
    }
  }, [page]);

  if (fromDate == "" || toDate == "") {
    const current = new Date();
    const CurrentYear = current.getFullYear();
    const CurrentMonth = current.getMonth();
    if (CurrentMonth < 4) {
      const newYear = `04-01-${CurrentYear - 1}`;
      const date = `${current.getMonth() + 1
        }-${current.getDate()}-${current.getFullYear()}`;
      const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
      setFromDate(newYear);
      setToDate(date1);
    } else {
      const newYear = `04-01-${CurrentYear}`;
      const date = `${current.getMonth() + 1
        }-${current.getDate()}-${current.getFullYear()}`;
      const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
      setFromDate(newYear);
      setToDate(date1);
    }
  }

  //search api

  const searchApiDetail = async (code, NoPage) => {
    const payloadValue = {
      keyword: code,
      Status: "",
      PageNo: NoPage,
      PageSize: 10,
    };

    const partnerPayload = {
      clientCode: code,
      page: NoPage,
      pageSize: 10,
    };

    const encPayload =
      userType === "partner" || partnerRoleNew === "partner"
        ? encryptData(JSON.stringify(partnerPayload))
        : AESEncryption(payloadValue);

    try {
      const response = await axios.post(
        userType === "partner" || partnerRoleNew === "partner"
          ? Partner_Reports.Client_Search_Partner_URL
          : Client_Search.Search_URL,
        userType === "partner" || partnerRoleNew === "partner" ? encPayload : `"${encPayload}"`,
        {
          headers: {
            "Content-Type":
              userType === "partner" || partnerRoleNew === "partner" ? "text/plain" : "application/json",
            Authorization: `Bearer ${partnerRoleNew === "partner" ? partnerSsoToken : storeToken}`,
            reserv: 1,
          },
        }
      );

      const res =
        userType === "partner" || partnerRoleNew === "partner"
          ? JSON.parse(decryptData(response?.data))
          : ApiResDecrypt(response?.data);

      if (res?.status === 0) {
        setCount(res?.data?.TotalCount);
        setNoNameFoundError("");
        setClientList((prev) =>
          page > 1 ? [...prev, ...res?.data?.clients] : res?.data?.clients
        );
      } else {
        setNoNameFoundError(res?.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setScrollLoader(false);
      setBlankClientCodeError("");
    }
  };

  const handleScroll = async (e) => {
    const element = e.target;
    if (
      element.scrollTop + element.offsetHeight + 1 >= element.scrollHeight &&
      !scrollLoader
    ) {
      if (count > 10 * page) {
        setPage((prev) => prev + 1);
        setScrollLoader(true);
      }
    }
  };
  //search api end

  const getCombineLedgerReport = async (fileType) => {
    setLoader(fileType === "grid");
    setSmallLoaderExcel(fileType === "excel");
    setSmallLoaderPdf(fileType === "pdf");
    setSmallLoaderMail(fileType === "mail");

    let payloadValue = {
      clientCode: clientCode,
      fromDate: fromDate,
      toDate: toDate,
      fileType: fileType,
      selectBy: flag,
      voucherType: voucher,
      exchangeType: exchange.length ? exchange.join(",") : null,
      reportType: report
    };
    console.log(payloadValue, "payloadValue");
    
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axios.post(
        Dashboard_Client_Report.CombineLedgerReport_URL,
        `"${encPayload}"`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${partnerRoleNew === "partner" ? partnerSsoToken : storeToken}`,
            reserv: 1,
          },
        }
      );
      const response = ApiResDecrypt(getDetails?.data);
      if (response?.status === 0) {
        setNoReportFound(false);
        if (fileType === "grid") {
          setGridVal(response?.data?.combine);
        } else if (fileType === "excel") {
          window.open(response?.data, "_self", "noopener,noreferrer");
        } else if (fileType === "pdf") {
          window.open(response?.data, "_blank", "noopener,noreferrer");
        } else if (fileType === "mail") {
          toast.success("Mail sent successfully");
        }
      } else {
        if (fileType !== "grid") {
          toast.error(response?.message);
        } else {
          setGridVal([]);
          setNoReportFound(response?.message);
        }
      }
    } catch (error) {
      console.error(error);
      setNoReportFound(error?.message);
      if (fileType !== "grid") {
        toast.error(error?.message);
      }
    } finally {
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setSmallLoaderMail(false);
    }
  };

  const handleOnClick = (e) => {
    if (clientCode) {
      if (e.target.value) {
        if(selectDuration){
        if (
          compareDate(fromDate) &&
          compareDate(toDate) &&
          checkDateRange(fromDate, toDate)
        ) {
          // setFileType(e.target.value);
          getCombineLedgerReport(e.target.value)
          setErrorResp("");
        } else {
          setErrorResp("Please Select Correct Date");
        }
      }
      else{
        setErrorResp("Please Select Duration")
      }
      }
    } else {
      setShow(false);
      setClientList([]);
      setBlankClientCodeError("*Please Enter Client Name/Code");
    }
  };

  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }

  const handleOnChange = (e) => {
    setGridVal([]);
    // setFileType("");
    setNoReportFound(false);
    if (e.target.value) {
      setFlag(e.target.value);
    }
  };

  const handleFromDateChange = (e) => {
    setNoReportFound(false);
    setGridVal([]);
    // setFileType("");
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setFromDate(d);
    setErrorResp("");
  };
  const handleToDateChange = (e) => {
    setNoReportFound(false);
    // setFileType([]);
    setGridVal("");
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(d);
    setErrorResp("");
  };
  

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");
  const getExchangeType = async () => {
    try {
      const getDetails = await axios.get(
        Dashboard_Client_Report.Get_ExchangeType,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const response = ApiResDecrypt(getDetails?.data);
      if (response?.status == 0) {
        setExchangeType(response?.data)
      }
      else {
        setExchangeType([])
      }
    } catch (error) {
      console.error(error)
    }
  }

  const getVoucherType = async () => {
    try {
      const getDetails = await axios.get(Dashboard_Client_Report.Get_VoucherType,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const response = ApiResDecrypt(getDetails?.data);
      if (response.status == 0) {
        setVoucherType(response?.data)
      }

    } catch (error) {
      console.error(error)
    }
  }

  const getReportType = async () => {
    try {
      const getDetails = await axios.get(Dashboard_Client_Report.Get_ReportType,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const response = ApiResDecrypt(getDetails?.data);
      if (response.status == 0) {
        setReportType(response?.data)
      }

    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    if (userType != "partner" && partnerRoleNew != "partner") {
      getExchangeType()
      getVoucherType()
      getReportType()
    }
  }, [])

  // useEffect(() => {
  //   if (fileType != "") {
  //     getCombineLedgerReport();
  //   }
  // }, [fileType]);

  const handleVoucherChange = (e) => {
    if (e.target.value) {
      setVoucher(e.target.value)
    }
    else {
      setVoucher("")
    }
    // setFileType("");
    setGridVal([]);
    setNoReportFound(false);
  }
  const handleExchangeChange = (e) => {
    const { value, checked } = e.target;

    if (checked) {
    setExchange((prev) => [...prev, value]);
    } else {
      setExchange((prev) => prev.filter((item) => item !== value));
    }
    setGridVal([]);
    setNoReportFound(false);
  }

  const handleReportChange = (e) => {
    if (e.target.value) {
      setReport(e.target.value)
    }
    else {
      setReport("")
    }
    // setFileType("");
    setGridVal([]);
    setNoReportFound(false);
  }
  const onChangeDuration=()=>{
    setNoReportFound(false);
    setGridVal("");
    setErrorResp(false);
   

  }
  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="reports combineledger">
        <div className="card-box">
          <div>
            <h2 className="report-title">{Constants.Combine_Ledger_Report}</h2>
          </div>

          <div className="row input-field-wrapper bottom-25">
            <div className="col-md-3 col-sm-3 col-6">
              <div className="form-group">
                <label className="form-label">{Constants.Client_Search}</label>
                <div className="rm-custom-dropdown">
                  <input
                    type="text"
                    className="input-st"
                    placeholder="Search here..."
                    autoComplete="off"
                    value={clientCode}
                    onChange={(e) => {
                      setClientCode(e.target.value.toUpperCase());
                      setShow(true);
                      setNoReportFound(false);
                      setBlankClientCodeError(false);
                    }}
                    onInput={(e) => {
                      const start = e.target.selectionStart;
                      const end = e.target.selectionEnd;
                      let input = e.target.value;
                      input = input
                          .toUpperCase()
                          .replace(/[^A-Z0-9\s]/g, "")
                          .replace(/\s+/g, " ")
                          .trimStart()
                          .slice(0, 100);

                      e.target.value = input;
                      e.target.setSelectionRange(start, end);
                      
                  }}
                  />
                  <button
                    className="rm-dropdown-btn"
                    onClick={() => setShow(!show)}
                  >
                    <span className="icon-right-arrow-triangle"></span>
                  </button>
                  {show && (
                    <ul
                      className="rm-mapping-ap border-0"
                      onScroll={handleScroll}
                    >
                      {clientList.map((item, i) => (
                        <li
                          key={i}
                          className="rm-maping-item-wrapper"
                          onClick={() => {
                            setClientCode(item?.clientCode);
                            setShow(false);
                          }}
                        >
                          {userType === "partner" || partnerRoleNew === "partner" ? 
                                <>
                                  <div> {item?.clientName}</div>
                                  <div> {item?.clientCode}</div>
                                </>
                              : 
                                <>
                                  <div> {item?.clientname}</div>
                                  <div> {item?.clientCode}</div>
                                </>
                              }
                        </li>
                      ))}
                      {scrollLoader && !loader && (
                        <div className="loader-center">
                          <LoaderForSearch />
                        </div>
                      )}
                      {noNameFoundError && !scrollLoader && (
                        <li
                          className="rm-maping-item-wrapper"
                          style={{ borderBottom: "none", fontSize: "12px" }}
                        >
                          {noNameFoundError}
                        </li>
                      )}
                    </ul>
                  )}
                </div>
                {blankClientCodeError && (
                  <span className="to-date-error">{blankClientCodeError}</span>
                )}
              </div>
            </div>
         
            <div className="col-md-3 col-sm-3 col-6">
              <div className="form-group">
                <DurationChangeComponent
                  setCustomShow={setCustomShow}
                  setFromDate={setFromDate}
                  setToDate={setToDate}
                  onChangeDuration={onChangeDuration}
                  selectDuration={selectDuration}
                  setSelectDuration={setSelectDuration}
                  showOptionCustom={false}
                  showOnlyFY={false}
                />
              </div>
              {errorResp&& !selectDuration && (
                  <span className="duration-date-error">{errorResp}</span>
                  )}
            </div>
            <div className="col-md-3 col-sm-3 col-6">
              <div className="combine-select">
                <Form.Select
                  aria-label="Default select example"
                  className="select"
                  onChange={handleOnChange}
                >
                  <option value="voucherDate">{Constants.Voucher_Date}</option>
                  <option value="effectiveDate">
                    {Constants.Effective_Date}
                  </option>
                </Form.Select>
              </div>
            </div>

            {userType != "partner" && partnerRoleNew != "partner" ?
              <div className="form-group col-md-3 col-sm-3 col-6">
                <label className="form-label">{Constants.Voucher_Type}</label>
                <select

                  className="report-custom-select"
                  onChange={handleVoucherChange}
                >
                  <option value="">
                    Select
                  </option>
                  {voucherType.map((item) => {
                    return (
                      <option value={item?.name}>{item?.value}</option>
                    )
                  })}


                </select>
              </div>
              : null
            }
            {userType != "partner" && partnerRoleNew != "partner" ?
              <div className="form-group col-md-3 col-sm-3 col-6 report-row">
                <label className="form-label">{Constants.Exchange}</label>

                <div className="rm-custom-dropdown" ref={exchangeDropdownRef}>
                  <input
                    type="text"
                    name="search-text"
                    id="Input_Exchange"
                    className="input-st ap cursor-point"
                    placeholder="Select Exchange"
                    autoComplete="off"
                    readOnly
                    value={
                      exchange.length > 0
                        ? exchangeType
                            .filter((item) => exchange.includes(item.value))
                            .map((item) => item.name)
                            .join(", ")
                        : ""
                    }
                    onClick={() => {
                      setExchangeShow(!exchangeShow);
                    }}
                  />
                  <button
                    type="button"
                    className="rm-dropdown-btn"
                    onClick={() => {
                      setExchangeShow(!exchangeShow);
                    }}
                  >
                    <span className="icon-right-arrow-triangle"></span>
                  </button>
                  {exchangeShow && (
                  <>
                    <ul
                      className="rm-mapping-ap apSearch border-0"
                      id="browsers-Rm"
                    >
                      {exchangeType &&
                        exchangeType?.map((item, key) => {
                          return (
                            <>
                              <li
                                className="rm-maping-item-wrapper combine-report"
                                key={key}
                              >
                                <input
                                  type="checkbox"
                                  name={item.name}
                                  className="segmentCheckbox"
                                  value={item.value}
                                  id={`exchange-id-${item.value}`}
                                  onChange={handleExchangeChange}
                                  checked={exchange.includes(item.value)}
                                />
                                <label
                                  htmlFor={`exchange-id-${item.value}`}
                                ></label>
                                <span className="for-label">
                                  {item.name}
                                </span>
                              </li>
                            </>
                          );
                        })}
                    </ul>
                  </>
                  )}
              </div>
              </div>
              :
              null}
            {userType != "partner" && partnerRoleNew != "partner" ?
              <div className="form-group col-md-3 col-sm-3 col-6 report-row">
                <label className="form-label">{Constants.Report_Type}</label>
                <select
                  className="report-custom-select"
                  onChange={handleReportChange}
                >
                  <option value="">
                    Select
                  </option>
                  {reportType.map((item, index) => {
                    return (
                      <option key={index} value={item?.value}>{item?.name}</option>
                    )
                  })}


                </select>
              </div>
              :
              null}
          
          </div>
          {/* {error&&<div>Mandatory to fill all the field</div>} */}
          <div>
            <div className="text-center search-btn-wrapper">
              <button
                value="grid"
                className="send-message"
                onClick={handleOnClick}
              >
                {Constants.Search}
              </button>
            </div>
            <div>
              <ReportTableHeader
                smallLoaderMail={smallLoaderMail}
                showEmailBtn={true}
                smallLoaderExcel={smallLoaderExcel}
                smallLoaderPdf={smallLoaderPdf}
                handleOnClick={handleOnClick}
              />
            </div>
          </div>
          <div className="for-grid-section">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : gridVal && gridVal.length > 0 ? (
              <div>
                <CombineLedger gridVal={gridVal} />
              </div>
            ) : (
              noReportFound && (
                <h4 className="report-error-message">
                  {noDataFound(noReportFound)}
                </h4>
              )
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default CombineLedgerReport;
